<app-nav-bar></app-nav-bar>
<div class="container flash">
    <flash-messages class="top-flash-messages"></flash-messages>
</div>
<router-outlet></router-outlet>
